<template>
  <div :style="style" ref="lavContainer"></div>
</template>

<script>
import lottie from 'lottie-web'

export default {
  name: 'lottie',
  props: {
    options: {
      type: Object,
      required: true,
    },
    url: String,
    height: Number,
    width: Number,
    background: String,
  },

  computed: {
    style() {
      return {
        width: this.width ? `${this.width}px` : undefined,
        height: this.height ? `${this.height}px` : undefined,
        maxWidth: this.width ? `${this.width}px` : '180px',
        maxHeight: this.height ? `${this.height}px` : '350px',
        background: this.background || '',
        margin: '0 auto',
      }
    },
  },

  mounted() {
    this.anim = lottie.loadAnimation(this.buildLoadConfig())
    this.$emit('animCreated', this.anim)
  },

  beforeDestroy() {
    if (this.anim) {
      this.anim.destroy()
      this.anim = null
    }
  },

  methods: {
    /**
     * lottie-web 约定：URL 字符串走 path，bundled JSON 对象走 animationData。
     * 旧代码把对象塞进 path，本地 JSON 永远加载失败。
     */
    buildLoadConfig() {
      const config = {
        container: this.$refs.lavContainer,
        renderer: 'svg',
        loop: this.options.loop !== false,
        autoplay: this.options.autoplay !== false,
      }
      const src = this.url || this.options.animationData
      if (!src) {
        return config
      }
      if (typeof src === 'string') {
        config.path = src
      } else {
        config.animationData = src
      }
      return config
    },
  },
}
</script>
